"use client";

import TREATMENTS from "@/constants/treatments";

import HowDoesItWork from "./sections/HowDoesItWork";
import MedicationOptions from "./sections/MedicationOptions";
import PatientVoices from "./sections/PatientVoices";
import Pricing from "./sections/Pricing";
import FeaturesBenefits from "./sections/SecondSection";
import TopSection from "./sections/TopSection";
import TransformingCare from "./sections/TransformingCare";

const Content = () => {
    return (
        <>
            <TopSection />
            <FeaturesBenefits />
            <PatientVoices />
            <MedicationOptions treatments={TREATMENTS} />
            <HowDoesItWork />
            <Pricing />
            <TransformingCare />
        </>
    );
};

export default Content;
